// Small localStorage-backed persistence helper for view-level filters (e.g. the 'huidige maand' /
// 'vorige maand' period filter and the billing type filter) that live outside the DevExtreme grid
// and are therefore not covered by Datagrid.vue's own dx-state-storing persistence (see its
// loadState/saveState). Mirrors that component's simple localStorage.getItem/setItem pattern,
// scoped per view via the storage key, and - like the grid state - is not namespaced by user, and
// uses localStorage (not sessionStorage/Vuex) so it survives a full page reload and a new session.
export function loadFilterValue<T>(storageKey: string, defaultValue: T): T {
  const stored = localStorage.getItem(storageKey);
  if (stored === null) {
    return defaultValue;
  }

  try {
    return JSON.parse(stored) as T;
  } catch {
    return defaultValue;
  }
}

export function saveFilterValue(storageKey: string, value: unknown): void {
  localStorage.setItem(storageKey, JSON.stringify(value));
}
